function getCompositeRenderErrorMessage(err: unknown): string {
  const error = err as { fullMessages?: string[]; message?: string };
  return error.fullMessages?.[0] || error.message || 'Failed to request render';
}

export default getCompositeRenderErrorMessage;
